var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"claim-type-form"}},[_c('div',{staticClass:"title-area"},[_c('common-text-medium',{attrs:{"text":"損種（必要情報）"}}),_c('div',{staticClass:"action-button-area"},[_c('div',{staticClass:"download-all-button",on:{"click":_vm.callDownloadAll}},[_c('feather-icon',{staticClass:"icon-button mr-2",attrs:{"icon":"DownloadIcon","svgClasses":"w-6 h-6"}}),_c('span',[_vm._v("一括ダウンロード")])],1),(_vm.isInsuranceCompany)?_c('feather-icon',{staticClass:"trash-icon-button ml-6",attrs:{"icon":"Trash2Icon","svgClasses":"h-6 w-6"},on:{"click":_vm.openDeleteModal}}):_vm._e()],1)],1),(_vm.isInsuranceCompany)?_c('hull-dropdown-select',{staticClass:"filter-input mt-4 mb-8",attrs:{"selectOptions":_vm.claimTypeOptions,"onSelect":_vm.onSelectClaimType,"selectedValue":_vm.selectedClaimType,"placeholder":"損種","bordered":"","isSearchable":true}}):_c('div',{staticClass:"mt-4 mb-6"},[_vm._v(_vm._s(_vm.claimTypeName))]),_vm._l((_vm.claimReportTypeSteps),function(step,index){return _c('div',{key:index,staticClass:"my-4"},[_c('vs-divider',{staticClass:"my-0"}),_c('common-text-medium',{staticClass:"mt-5",attrs:{"text":step.name}}),_vm._l((step.claim_report_type_step_items),function(claimReportTypeStepItem,index){return _c('div',{key:index,staticClass:"my-5"},[(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              1
          )?_c('form-one-line-text',{key:claimReportTypeStepItem.version + 'oneline',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              2
          )?_c('form-multi-line-text',{key:claimReportTypeStepItem.version + 'multiline',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):_vm._e(),(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              3
          )?_c('form-file-manager',{key:claimReportTypeStepItem.version + 'file',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":fileList =>
              _vm.callSaveFile(
                _vm.claimReportId,
                claimReportTypeStepItem.claim_report_item.id,
                fileList
              ),"onClickDelete":fileName =>
              _vm.callDeleteFile(
                _vm.claimReportId,
                claimReportTypeStepItem.claim_report_item.id,
                fileName
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"uploadFile":file =>
              _vm.uploadFile(claimReportTypeStepItem.claim_report_item.id, file),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status),"onClickDownloadFile":(fileName, token) =>
              _vm.downloadFile(
                _vm.insurerEnterpriseId,
                _vm.ownerEnterpriseId,
                _vm.claimReportId,
                claimReportTypeStepItem.claim_report_item.id,
                fileName,
                token,
                false
              ),"onClickFileLink":(fileName, token) =>
              _vm.downloadFile(
                _vm.insurerEnterpriseId,
                _vm.ownerEnterpriseId,
                _vm.claimReportId,
                claimReportTypeStepItem.claim_report_item.id,
                fileName,
                token,
                true
              )}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              4
          )?_c('form-check-box',{key:claimReportTypeStepItem.version + 'check',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"options":claimReportTypeStepItem.claim_report_item.claim_item.choices,"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              5
          )?_c('form-dropdown-select',{key:claimReportTypeStepItem.version + 'dropdown',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"options":claimReportTypeStepItem.claim_report_item.claim_item.choices,"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              6
          )?_c('form-radio-button',{key:claimReportTypeStepItem.version + 'radio',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"options":claimReportTypeStepItem.claim_report_item.claim_item.choices,"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):_vm._e(),(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              7
          )?_c('form-contact',{key:claimReportTypeStepItem.version + 'contact',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createdDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              8
          )?_c('form-link',{key:claimReportTypeStepItem.version + 'link',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              9
          )?_c('form-date',{key:claimReportTypeStepItem.version + 'date',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              10
          )?_c('form-time',{key:claimReportTypeStepItem.version + 'time',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              11
          )?_c('form-coordinates',{key:claimReportTypeStepItem.version + 'coordinates',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              12
          )?_c('form-price',{key:claimReportTypeStepItem.version + 'price',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"selectPlaceholder":"円","textPlaceholder":"金額","isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):(
            claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
              13
          )?_c('form-unit',{key:claimReportTypeStepItem.version + 'unit',attrs:{"title":claimReportTypeStepItem.claim_report_item.claim_item.name,"inputValue":claimReportTypeStepItem.claim_report_item.input_values,"initialSwitchValue":claimReportTypeStepItem.mandatory,"createDate":Date.parse(claimReportTypeStepItem.claim_report_item.created_at),"updateDate":Date.parse(claimReportTypeStepItem.claim_report_item.updated_at),"onClickSave":inputValue =>
              _vm.callSaveForm(
                claimReportTypeStepItem.claim_report_item.id,
                inputValue,
                claimReportTypeStepItem.claim_report_item.version
              ),"onSwitchChange":value =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                value,
                claimReportTypeStepItem.status,
                claimReportTypeStepItem.version
              ),"onClickHelp":() =>
              _vm.openDescriptionModal(
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_owner,
                claimReportTypeStepItem.claim_report_item.claim_item
                  .description_insurer
              ),"selectPlaceholder":"GT","textPlaceholder":"数値","isAdmin":_vm.isInsuranceCompany,"mandatory":claimReportTypeStepItem.mandatory,"onStatusChange":status =>
              _vm.callUpdateStepItem(
                _vm.claimReportId,
                _vm.claimReportTypeId,
                step.id,
                claimReportTypeStepItem.id,
                claimReportTypeStepItem.mandatory,
                status.value,
                claimReportTypeStepItem.version
              ),"statusOptions":_vm.stepItemStatusOptions,"initialStatusValue":_vm.getStatusFromValue(claimReportTypeStepItem.status)}}):_vm._e()],1)})],2)})],2),_c('common-modal',{ref:"DeleteModal",attrs:{"title":""},scopedSlots:_vm._u([{key:"contents",fn:function(){return [_c('div',{staticClass:"delete-container"},[_vm._v("\n        "+_vm._s(_vm.claimTypeName)+"を削除した場合、保存されていた情報は復元できません。本当に削除しますか？\n        "),_c('div',{staticClass:"button-area"},[_c('common-button',{staticClass:"button",attrs:{"title":"キャンセル","click":_vm.closeDeleteModal,"color":"#BDBDBD","text-color":"#757575","type":"border"}}),_c('common-button',{staticClass:"button",attrs:{"title":"削除","click":() => _vm.callDeleteReportClaimType()}})],1)])]},proxy:true}])}),_c('common-modal',{ref:"DescriptionModal",attrs:{"title":""},scopedSlots:_vm._u([{key:"contents",fn:function(){return [_c('div',{staticClass:"description-container"},[(_vm.isInsuranceCompany)?[_c('div',{staticClass:"description-title"},[_vm._v("管理者専用説明")]),_c('div',{staticClass:"description-content"},[_vm._v("\n            "+_vm._s(_vm.displayDescriptionOwner)+"\n          ")])]:_vm._e(),_c('div',{staticClass:"description-title mt-8"},[_vm._v("保険契約者向け説明")]),_c('div',{staticClass:"description-content"},[_vm._v("\n          "+_vm._s(_vm.displayDescriptionInsurer)+"\n        ")])],2)]},proxy:true}])}),_c('common-modal',{ref:"ChangeClaimTypeModal",attrs:{"title":""},scopedSlots:_vm._u([{key:"contents",fn:function(){return [_c('div',{staticClass:"change-claim-type-container"},[_vm._v("\n        損害種類を変更すると、ステップおよび必要情報の項目が変更されます。"),_c('br'),_vm._v("変更前に登録された必要情報は変更後も引き継がれます。\n        "),_c('div',{staticClass:"button-area"},[_c('common-button',{staticClass:"button",attrs:{"title":"キャンセル","click":_vm.closeChangeClaimTypeModal,"color":"#BDBDBD","text-color":"#757575","type":"border"}}),_c('common-button',{staticClass:"button",attrs:{"title":"変更","click":() => _vm.callUpdateReportClaimType()}})],1)])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }